"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentKlassCodeLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _studentLoginBg = _interopRequireDefault(require("../assets/student-login-bg.png"));
var _teacherKlasscodeHelp = _interopRequireDefault(require("../assets/teacher-klasscode-help.png"));
var _KlassCodeInput = require("./KlassCodeInput");
require("./styles.scss");
var _state = require("./../../authSignin/state");
var _pushEventToGTM = require("../../commonHelpers/pushEventToGTM");
var _SuiTurnstile = require("schoolUiComponents/SuiTurnstile");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StudentKlassCodeLogin = function StudentKlassCodeLogin() {
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent,
    getFromPage = _useAuthSigninState.getFromPage;
  (0, _react.useEffect)(function () {
    if (window.location.hash.includes('student-klasscode')) {
      trackEventsForGuests("Viewed Class Code Input Screen", {
        "mp_login_user_type": "student",
        "From page": getFromPage() || "Direct URL entered"
      }, {
        send_mixpanel: true
      });
    }
    (0, _pushEventToGTM.pushEventToGTM)('viewed_class_code_screen', {
      'Intent for': 'login',
      'Screen type': 'page',
      'From Page': 'signin'
    });
  }, []);
  var userNameLoginClickHandler = function userNameLoginClickHandler() {
    sendInteractedEvent({
      clickedOn: "Login via QR code"
    });
    // trackAnalyticsEvent('Student Login Via username');
    // sendEvent(`Student Login Via username`)
  };

  var sendInteractedEvent = function sendInteractedEvent(_ref) {
    var _ref$interactionDetai = _ref.interactionDetails,
      interactionDetails = _ref$interactionDetai === void 0 ? '' : _ref$interactionDetai,
      _ref$clickedOn = _ref.clickedOn,
      clickedOn = _ref$clickedOn === void 0 ? '' : _ref$clickedOn;
    trackEventsForGuests("Interacted Class Code Input Screen", {
      "mp_login_user_type": "student",
      "Interaction details": interactionDetails,
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_SuiTurnstile.SuiTurnstileProvider, {
    action: "KLASS_CODE_LOGIN",
    userType: "student",
    featureName: _SuiTurnstile.TurnstileEnabledFeature.klass_code_login,
    "data-sentry-element": "SuiTurnstileProvider",
    "data-sentry-component": "StudentKlassCodeLogin",
    "data-sentry-source-file": "KlassCodeLogin.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back",
    onClick: function onClick() {
      sendInteractedEvent({
        clickedOn: "Back Button"
      });
      window.location.hash = "#student";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-bg"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _studentLoginBg["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-body"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Enter your Class Code"), /*#__PURE__*/_react["default"].createElement(_KlassCodeInput.KlassCodeInput, {
    "data-sentry-element": "KlassCodeInput",
    "data-sentry-source-file": "KlassCodeLogin.tsx"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Login via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "#student-qrcode?fromPage=Class code input screen",
    onClick: userNameLoginClickHandler
  }, "QR code")), /*#__PURE__*/_react["default"].createElement("img", {
    src: _teacherKlasscodeHelp["default"],
    alt: "Don\u2019t know your class code? Ask your teacher for help"
  }))));
};
exports.StudentKlassCodeLogin = StudentKlassCodeLogin;